import React, { useCallback, useState } from 'react';

import { Button, List } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import OtherForm from '../../Form/Other';

const HOTMART = 4;

interface IProps {
  other: any;
  onRemove: any;
  onEdit?: any;
  deliveries?: any;
  index: any;
  offer?: any;
}

const Other: React.FC<IProps> = ({ other, onRemove, onEdit, deliveries, index }) => {
  const [modal, setModal] = useState(false);
  const otherName = (item: any) => (item?.id ? item.method_name : item.name);

  const openModal = useCallback(() => {
    setModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setModal(false);
  }, []);

  const onOk = useCallback(
    (newItem: any, old: any) => {
      setModal(false);
      if (onEdit) onEdit(newItem, old);
    },
    [onEdit]
  );

  return (
    <>
      <List.Item
        className='border-outline-default mb-3 cursor-pointer rounded-xl border bg-(--uizz-antd-color-bg-container) px-4 py-3'
        onClick={openModal}
        actions={
          other.can_modify
            ? [
                <Button
                  key='remove'
                  type='text'
                  className='m-0'
                  icon={<Icon.Trash2 size={16} className='size-4' />}
                  onClick={e => {
                    e.stopPropagation();
                    onRemove(otherName(other), index);
                  }}
                />
              ]
            : undefined
        }
      >
        <List.Item.Meta
          className='items-center'
          avatar={
            <div className='flex size-10 items-center justify-center'>
              <Icon.SlidersHorizontal size={28} className='size-7' />
            </div>
          }
          title={otherName(other)}
          description={other?.url ?? 'Entrega Customizada'}
        />
      </List.Item>
      {other.can_modify && other?.method_id !== 9 && modal && (
        <OtherForm
          deliveries={deliveries}
          other={other}
          isModal={true}
          open={modal}
          onClose={closeModal}
          onOk={onOk}
          hasHotmart={Number(other.method_id) === HOTMART}
        />
      )}
    </>
  );
};

export default Other;
